<template>
    <div>
        <page-header></page-header>

        <!-- Heading and Filename -->
        <div>
            <table class="header-section">
                <tbody>
                    <tr>
                <td>
                    IMPORT TASKS
                </td>
                <td style="color: grey;">
                    {{ fileName }}
                </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <button class="back-button" @click="goBack">Back</button>

        <!-- Import Information -->
        <div :class="{ 'error-info-box': skippedTasks.length === importedTasks.length }" class="info-box">
            <!-- Display success or failure message based on the condition -->
            <div v-if="skippedTasks.length === importedTasks.length">
                Tasks Import - Unsuccessful.
                <li>Total records: {{ importedTasks ? importedTasks.length : 0 }}</li>
                <li>Valid tasks: {{ validTaskCount }}</li>
                <li style="color:red">Skipped tasks: {{ skippedTasks ? skippedTasks.length : 0 }}</li>            
                <p></p>
                Tasks added to Database: {{ validTaskCount }}
            </div>
            <div v-else>
                Tasks Import - Successful!
                <li>Total records: {{ importedTasks ? importedTasks.length : 0 }}</li>
                <li>Valid tasks: {{ validTaskCount }}</li>
                <li style="color:red">Skipped tasks: {{ skippedTasks ? skippedTasks.length : 0 }}</li>            
                <p></p>
                Tasks added to Database: {{ validTaskCount }}
            </div>
        </div>
        <div class="skippedTasksDisplay">
            <div v-if="Object.keys(groupedIssues).length">
                <div v-for="(issues, index) in groupedIssues" :key="index" class="grey-line">
                    <!-- Display all issues for this index -->
                    <ul>
                        <br>
                        <li style="font-weight:bold">
                           {{ isWarningOnlyRow(issues) ? 'Imported with Warning' : 'Skipped Task' }} (Row: {{ parseInt(this.ignoreFirstRow ? parseInt(index) + 2 : parseInt(index) + 1) }})
                        </li>
                        <ul>
                            <li style="font-weight:bold" v-for="(issue, issueIndex) in issues" :key="issueIndex">
                                {{ issue.message }}
                            </li>
                        </ul>
                    </ul>
                    <i style="color:grey; margin-left:20px;">Provided fields</i>
                    <div class="task-list">
                        <!-- Check if there is an error in importedTasks -->
                        <ul
                            v-if="importedTasks[parseInt(this.ignoreFirstRow ? parseInt(index) + 1 : parseInt(index))] && importedTasks[parseInt(this.ignoreFirstRow ? parseInt(index) + 1 : parseInt(index))].error">
                            <li v-for="(field, fieldIndex) in importedTasks[parseInt(this.ignoreFirstRow ? parseInt(index) + 1 : parseInt(index))].row"
                                :key="fieldIndex">
                                {{ field }}
                            </li>
                        </ul>
                        <!-- If no error, display the regular fields -->
                        <ol v-else>
                            <li><strong>Chapter No: &nbsp;</strong> {{ importedTasks[parseInt(this.ignoreFirstRow ? parseInt(index) : parseInt(index) -1)]?.chapt_no || '' }}</li>
                            <li><strong>Task no: &nbsp;</strong> {{ importedTasks[parseInt(this.ignoreFirstRow ? parseInt(index) : parseInt(index) -1)]?.task_no || '' }}</li>
                            <li><strong>MT/AT: &nbsp;</strong> {{ importedTasks[parseInt(this.ignoreFirstRow ? parseInt(index) : parseInt(index) -1)]?.manob || '' }}</li>
                            <li><strong>Scope: &nbsp;</strong> {{ importedTasks[parseInt(this.ignoreFirstRow ? parseInt(index) : parseInt(index) -1)]?.scope || '' }}</li>
                            <li><strong>Description: &nbsp;</strong> {{ importedTasks[parseInt(this.ignoreFirstRow ? parseInt(index) : parseInt(index) -1)]?.description || '' }}</li>
                            <li><strong>Reference: &nbsp;</strong> {{ importedTasks[parseInt(this.ignoreFirstRow ? parseInt(index) : parseInt(index) -1)]?.reference || '' }}</li>
                            <!-- <li><strong>Skill: &nbsp;</strong> {{ importedTasks[parseInt(this.ignoreFirstRow ? parseInt(index) : parseInt(index) -1)]?.skill || '' }}</li>
                            <li><strong>P1: &nbsp;</strong> {{ importedTasks[parseInt(this.ignoreFirstRow ? parseInt(index) : parseInt(index) -1)]?.P1 || '' }}</li>
                            <li><strong>P2: &nbsp;</strong> {{ importedTasks[parseInt(this.ignoreFirstRow ? parseInt(index) : parseInt(index) -1)]?.P2 || '' }}</li> -->
                            <li><strong>Category: &nbsp;</strong> {{ importedTasks[parseInt(this.ignoreFirstRow ? parseInt(index) : parseInt(index) -1)]?.category || '' }}</li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import pageHeader from '@/components/Examiner/Header.vue';

export default {
    data() {
        return {};
    },
    components: {
        pageHeader,
    },
    computed: {
        skippedTasks() {
            console.log(this.$store.state.skippedTasks);
            return this.$store.state.skippedTasks;
        },
        issues() {
            return this.$store.state.issues;
        },
        importedTasks() {
            return this.$store.state.importedTasks;
        },
        validTaskCount() {
            return this.importedTasks.length - this.skippedTasks.length;
        },
        groupedIssues() {
            return this.issues.reduce((acc, issue) => {
                // Adjust the index so it matches the actual position in importedTasks
                const adjustedIndex = this.ignoreFirstRow ? issue.index - 2 : issue.index - 1;

                if (!acc[issue.index]) {
                    acc[issue.index] = [];
                }

                // Attach adjustedIndex for later use in the template if needed
                issue._adjustedIndex = adjustedIndex;

                acc[issue.index].push(issue);
                return acc;
            }, {});
        },
        fileName() {
            return this.$store.state.fileName;
        },
        ignoreFirstRow() {
            return this.$store.state.ignoreFirstRow;
        }
    },
    methods: {
        goBack() {
            this.$router.push({ name: 'importTasks' });
        },
        isWarningOnlyRow(issues) {
            return issues.every(issue => issue.severity === 'warning');
        },
    },
    mounted() {
        console.log("importedTasks:", this.importedTasks);
        console.log("issues from Vuex:", this.$store.state.issues);
        console.log("ignore first row:", this.$store.state.ignoreFirstRow);
    }
}
</script>

<style scoped>
.header-section {
    text-align: center;
    height: 90%;
}

.header-section td{
    font-size: 30px;
    padding-left: 30px;
}

.info-box {
    border: 1px solid #ccc;
    padding: 20px;
    padding-left: 40px;
    margin: 0px 20px;
    color: #137e2a;
    font-weight: bold;
    background-color: #bfeec7;
    width: 60%;
    height: 180px;
    text-align: left;
}

.error-info-box {
    border: 1px solid #a31616;
    padding: 20px;
    padding-left: 40px;
    margin: 0px 20px;
    color: #550000;
    font-weight: bold;
    background-color: rgba(255, 109, 109, 0.555);
    width: 60%;
    height: 180px;
    text-align: left;
}


.skippedTasksDisplay {
    text-align: left;
    margin-top: 10px;
    margin-left: 1%;
    background-color: rgb(250, 248, 248);
    width: 98%;
}

.task-list {
    background-color: #f0e7e7;
}

.back-button {
  position: absolute;
  /* Adjust the top position as needed */
  right: 60px;
  /* Adjust the right position as needed */
  width: 100px;
  border-radius: 5px;
  background-color: #c1e0bf;
  font-size: 14px;
  border: 2px solid black;
  padding: 3px;
}

.back-button:hover {
  background-color: #abc7a9;
  cursor: pointer;
}

.grey-line {
    border-top: 1px solid rgb(179, 179, 179);
    margin-top: 10px;
    margin-bottom: 10px;
    max-width: 100%;
}
</style>